export const isValidIpV4 = (ip) => {
  const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return ipRegex.test(ip);
}

export const compareStartAndEndIp = (startIp, endIp) => {
  const startIpParts = startIp.split('.').map(Number);
  const endIpParts = endIp.split('.').map(Number);

  for (let i = 0; i < 4; i++) {
    if (startIpParts[i] < endIpParts[i]) {
      return true;
    } else if (startIpParts[i] > endIpParts[i]) {
      return false;
    }
  }

  return true;
}

export const isValidSubnetMask = (subnetMask) => {
  const subnetMaskRegex = /^(255|254|252|248|240|224|192|128|0)(\.0){3}$|^(255|254|252|248|240|224|192|128)(\.0){2}\.(0|128|192|224|240|248)$|^(255|254|252|248)(\.0){1}\.(0|128|192)$|^(255)(\.0){1}\.(0)$/;
  return subnetMaskRegex.test(subnetMask);
}

export const ipToLong = (ip) => {
  return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet), 0) >>> 0;
}

export const longToIp = (long) => {
  return [
    (long >>> 24) & 255,
    (long >>> 16) & 255,
    (long >>> 8) & 255,
    long & 255,
  ].join('.');
}

export const getSubnetInfo = (cidr) => {
  const [ipStr, prefixLengthStr] = cidr.split('/');
  const prefixLength = parseInt(prefixLengthStr, 10);
  if (prefixLength < 0 || prefixLength > 32) throw new Error('Invalid subnet mask');

  const ip = ipToLong(ipStr);
  const mask = prefixLength === 0 ? 0 : ~((1 << (32 - prefixLength)) - 1) >>> 0;

  const network = ip & mask;
  const broadcast = network | (~mask >>> 0);
  const firstHost = network + 1;
  const lastHost = broadcast - 1;
  const hostCount = Math.max(0, broadcast - network - 1);

  return {
    ip: ipStr,
    prefix: prefixLength,
    subnetMask: longToIp(mask),
    network: longToIp(network),
    broadcast: longToIp(broadcast),
    firstHost: prefixLength >= 31 ? 'N/A' : longToIp(firstHost),
    lastHost: prefixLength >= 31 ? 'N/A' : longToIp(lastHost),
    usableHosts: hostCount,
  };
}

export const isSameSubnet = (ip1, ip2, subnetMask) => {
  if (!isValidIpV4(ip1) || !isValidIpV4(ip2) || !isValidIpV4(subnetMask)) {
    return false;
  }
  const ip1Long = ipToLong(ip1);
  const ip2Long = ipToLong(ip2);
  const maskLong = ipToLong(subnetMask);
  return (ip1Long & maskLong) === (ip2Long & maskLong);
}